"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicsForThisYear = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TopicsForThisYear = props => {
  const {
    t
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-TopicsForThisYear"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__green-Capital con-text__green-Capital--large con-centered"
  }, t("Pages.TopicsForThisYear.Title")), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-TopicsForThisYear__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex-container"
  }, t("Pages.TopicsForThisYear.FirstHeader") && t("Pages.TopicsForThisYear.FirstDescription") && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h5"
  }, t("Pages.TopicsForThisYear.FirstHeader")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text  con-text__large-medium"
  }, t("Pages.TopicsForThisYear.FirstDescription"))), t("Pages.TopicsForThisYear.SecondHeader") && t("Pages.TopicsForThisYear.SecondDescription") && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h5"
  }, t("Pages.TopicsForThisYear.SecondHeader")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text  con-text__large-medium"
  }, t("Pages.TopicsForThisYear.SecondDescription"))), t("Pages.TopicsForThisYear.ThirdHeader") && t("Pages.TopicsForThisYear.ThirdDescription") && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h5"
  }, t("Pages.TopicsForThisYear.ThirdHeader")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text  con-text__large-medium"
  }, t("Pages.TopicsForThisYear.ThirdDescription"))))));
};
exports.TopicsForThisYear = TopicsForThisYear;
TopicsForThisYear.propTypes = {
  t: _propTypes.default.func
};